/**
 * dialog 方案 发布订阅
 * dialog 自身生命周期 start end 两个事件
 * dialog.config.js 枢纽管理start end 顺序
 * dialog.config.js 内 $on('end',(name) => {
 *      $emit('start', name)
 * })
 * 所有dialog 挂载到global 与页面逻辑相关则独立出来不参与顺序
 */

import Bus from '@/utils/bus'
import { config } from './config'
export const eventstart = 'GLOBAL_ACTIVE_DIALOG_START'
export const eventend = 'GLOBAL_ACTIVE_DIALOG_END'
const isDebug = false
// 备份数据
let sortconfig = getInitOption(config)
isDebug && console.log(sortconfig)
// 标记只触发一次
let EventModulesLock = false
// 事件集合长度
const sortconfig_len = sortconfig.length

// 事件集合回调
const eventCallbacks = {}

// 路由
let $route = null
export default function RunEvents(route) {
	isDebug && console.log('start run event')
	$route = route
	setTimeout(() => {
		let startOpt = getNext()
		if (startOpt) {
			EventStart(startOpt)
		}
	}, 300)
	if (EventModulesLock) {
		return false
	}
	EventModulesLock = true
	// 发布end事件
	Bus.$on(eventend, obj => {
		if (!obj) {
			return false
		}
		let name = typeof obj === 'string' ? obj : obj.name

		let params = getNext(name, true)
		if (params && params.name) {
			try {
				if (typeof obj !== 'string' && obj.extend) {
					let extend = params.extend || {}
					params.extend = { ...extend, ...obj.extend }
				}
				// Bus.$emit(eventstart, params)
				EventStart(params)
			} catch (err) {
				console.log(err)
				// Bus.$emit(eventstart, params)
				EventStart(params)
			}
		}
	})
}

export function EventStart(opt) {
	// if(eventCallbacks[opt.name]) {
	isDebug && console.log(`event start: ${opt.name}`)
	Bus.$emit(eventstart, { ...opt })
	// }
}
// 结束事件
export function EventEnd(name) {
	isDebug && console.log(`event end: ${name}`)
	// 移除事件
	// EventOffEventSatrt(name)
	// 提交end 事件
	Bus.$emit(eventend, name)
}
// 订阅 eventstart事件
export function EventOnEventStart(name, fn) {
	if (typeof fn !== 'function') {
		throw new Error(`Event name : function callback is not a function`)
	}
	eventCallbacks[name] = fn
	Bus.$on(eventstart, eventCallbacks[name])
}

// 移除某事件的开始绑定
export function EventOffEventSatrt(name) {
	if (eventCallbacks[name] && typeof eventCallbacks[name] === 'function') {
		Bus.$off(eventstart, eventCallbacks[name])
		delete eventCallbacks[name]
	}
}

// 获取栈内下一个订阅事件
// 按条件进行查询下一个
// 时间关系暂时先这样轮询
function getNext(name, isFinish) {
	let params = null, cur = !name ? -1 : null
	sortconfig.forEach((v, i) => {
		//
		if (name && name === v.name) {
			cur = i
			// 需要的时候统计 结束次数
			if (isFinish) {
				if (v.finished) {
					v.finished++
				} else {
					v.finished = 1
				}
			}
		}
		// 查找在当前name后符合条件的下一个事件
		if (i <= sortconfig_len - 1 && !params && i > cur && cur !== null && ifEventRun(v)) {
			let next = { ...v }
			params = {
				extend: next.extend || null,
				name: next.name
			}
		}
	})
	isDebug && console.log(`getNext: sortconfig: `, sortconfig)
	isDebug && console.log(!name ? 'first: ' : 'next: ', params)
	return params
}

// 获取下一个符合条件的事件
function ifEventRun(opt) {
	// 执行次数
	// if (opt.finished >= opt.run && opt.run !== -1) {
	// 	return false
	// }
	// 路由
	if ($route && opt.routers && opt.routers.length > 0 && opt.routers.indexOf($route.path) === -1) {
		return false
	}
	if ($route && opt.unrouters && opt.unrouters.length > 0 && opt.unrouters.indexOf($route.path) > -1) {
		return false
	}
	return true
}

// init option
function getInitOption(opt) {
	let r = []
	opt.forEach(v => {
		r.push({
			run: 1,
			finished: 0,
			routers: [],
			extend: {},
			...v
		})
	})
	return r
}
